<template>
  <div>
    <div class="fz-FF0000 addjia" :class="{'addjian': expand}" ref="contentDiv" v-html="content"></div>
    <div class="fz-409EFF" @click="toggleExpand" v-if="needsToggle">{{ expand ? '收起' : '展开' }}</div>
  </div>
</template>

<script>
export default {
  name: 'YinCan',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      expand: false,
      needsToggle: false,
      isChecking: false
    }
  },
  mounted() {
    this.checkNeedsToggle()
  },
  updated() {
    if (!this.isChecking) {
      this.checkNeedsToggle()
    }
  },
  methods: {
    toggleExpand() {
      this.expand = !this.expand
    },
    checkNeedsToggle() {
      if (this.isChecking) return
      
      this.isChecking = true
      this.$nextTick(() => {
        if (this.$refs.contentDiv) {
          // 临时移除展开状态来测量原始高度
          const wasExpanded = this.expand
          this.expand = false
          
          this.$nextTick(() => {
            const scrollHeight = this.$refs.contentDiv.scrollHeight
            const clientHeight = this.$refs.contentDiv.clientHeight
            this.needsToggle = scrollHeight >= clientHeight
            
            // 恢复原始展开状态
            this.expand = wasExpanded
            
            // 重置检查标志
            this.$nextTick(() => {
              this.isChecking = false
            })
          })
        } else {
          this.isChecking = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addjia {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: all 0.3s ease;
}

.addjian {
  -webkit-line-clamp: unset;
  display: block;
}

.fz-FF0000 {
  color: #FF0000;
  font-size: 14px;
  line-height: 1.5;
//   margin-bottom: 8px;
}

.fz-409EFF {
  color: #409EFF;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  
  &:hover {
    text-decoration: underline;
  }
}
</style>